import { UseMutateFunction, useMutation, useQuery } from "@tanstack/react-query";
import { CreateCommanWay, GetCommanWay, ListCommanWay } from "API/commonApi";
import { AxiosResponse } from "axios";
import { Button, Img } from "components";
import { GlowingEffect } from "components/ui/glowing-effect";
import { TextHoverEffect } from "components/ui/text-hover-effect";
import { Timeline } from "components/ui/timeline";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import Swal from "sweetalert2";
import UseToast from "utils/AfToast";
import { roles } from "utils/constant";
import { cn, get_file_url } from "utils/lib-utils";

const CustomerTrackingAwb = () => {
  const BASE_URL = process.env.REACT_APP_BACKEND_URL;
  const navigator = useNavigate();

  const [awbNo, setAwbNo] = useState("");
  const [awbTrackingData, setAwbTrackingData] = useState<any>({
    tracking_data: [],
    bookingDate: "",
    awbData: {},
    bookingData: {},
  });
  const [searchParams, setSearchParams] = useSearchParams();
  const [deliveryDoneInfo, setDeliveryDoneInfo] = useState<any>({});
  const [productList, setProductList] = useState<any>([]);
  const [commentsList, setCommentsList] = useState<any>([]);

  const [isImageOpen, setIsImageOpen] = useState<any>("");

  const [showImg, setShowImg] = useState<any>(false);
  const [showVolume, setShowVolume] = useState<any>(false);
  const [showDataLogger, setShowDataLogger] = useState<boolean>(false);

  const [canEditBook, setCanEditBook] = useState<any>(false);
  React.useEffect(() => {
    const userD = (() => { const auth = localStorage.getItem("auth"); return auth ? JSON.parse(auth) : {}; })();
    if (Object.keys(userD).length) {
      if (userD.state.user.role_name == 1 || userD.state.user.role_name == 2 || userD.state.user.role_name == 3) {
        setCanEditBook(true);
      }
    }
  }, []);

  useQuery(["admin_product_list"], () => ListCommanWay("/admin/product/list", {}, {}), {
    keepPreviousData: true,
    onSuccess(data) {
      if (data.status == "SUCCESS") {
        setProductList(data.data.data);
      }
    },
    onError: (data) => {},
  });

  const {
    mutate,
    isLoading: isloading,
  }: {
    mutate: UseMutateFunction<AxiosResponse<any, any>, unknown, any, unknown>;
    isLoading: any;
  } = useMutation((awb_no) => GetCommanWay("/admin/proof_of_delivery/track/" + awb_no, {}, {}), {
    onSuccess: (data: any) => {
      console.log(data, data.status == "SUCCESS");
      if (data.status == "SUCCESS") {
        let resData = data.data;

        try {
          let lastMsg = resData.tracking_data[resData.tracking_data.length - 1]?.message_code;
          if (lastMsg.includes("DRS Generated")) {
            resData.tracking_data[resData.tracking_data.length - 1].message_code = "Out for Delivery";
          }
        } catch (ignored) {}

        resData.tracking_data.forEach((t) => {
          const msg = t.message_code?.toLowerCase() || "";
          const isTransitMsg =
            msg.includes("motherbag tally") ||
            msg.includes("motherbag out-scan") ||
            msg.includes("motherbag in-scan") ||
            msg.includes("send to thirdparty") ||
            msg.includes("sent to thirdparty");
          if (isTransitMsg) {
            t.message_code = "In Transit";
          }

          if(msg.includes("motherbag out-scan")){
            t.message_code = "Out from Hub: " + (t.location || t.subbranch?.branch_name);
          }

          if(msg.includes("motherbag in-scan")){
            t.message_code = "In Scan: " + (t.location || t.subbranch?.branch_name);
          }

          if (t.message_code?.toLowerCase().includes("drs generated")) {
            t.message_code = "Out for Delivery";
          }

          if (t.message_code?.toLowerCase().includes("shipment delivered")) {
            t.message_code = "Shipment Delivered";
            t.subtitle = "Delivered to " + t.receiver;
            t.createdAt = t.createdAt.slice(0, -3);
            t.updatedAt = t.updatedAt.slice(0, -3);
            setDeliveryDoneInfo(t);
          } else {
            t.updatedAt = t.updatedAt.slice(0, -9);
          }
        });

        let finalTrackData = [];
        let inTransitCame = 0;

        console.log([...resData.tracking_data]);

        let locationName = resData.tracking_data[0]?.location;
        if (locationName == "") {
          if (resData.tracking_data[0]?.subbranch?.id == resData.tracking_data[0]?._addedBy?.subbranch) {
            locationName = resData.tracking_data[0]?.subbranch?.branch_name;
          }
        }

        resData.tracking_data.forEach((t) => {
          if (t.message_code == "In Transit") {
            if (inTransitCame == 0) {
              inTransitCame += 1;
            } else {
              //return;
            }
          }

          if (locationName === resData.bookingData?.shipper_city) {
            finalTrackData.push(t);
          } else {
            if (t.message_code !== "In Transit" && t.message_code !== "Shipment Booked") {
              finalTrackData.push(t);
            }
          }
        });
        resData.tracking_data = finalTrackData;

        console.log([...resData.tracking_data]);
        setAwbTrackingData(resData);

        /*if (data.data.tracking_data) {
          try {
            data.data.tracking_data.forEach((t) => {
              if (t.message_code == "Shipment Delivered" || t.message_code == "0 - Shipment Delivered") {
                t.createdAt = t.createdAt.slice(0, -3);
                setDeliveryDoneInfo(t);
              }
            });
          } catch (e) {}
        }*/
      } else {
        UseToast(data.message, "error");
      }
    },
    onError: (data: any) => {
      typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
    },
  });

  const handleSubmit = () => {
    setAwbTrackingData({
      tracking_data: [],
      bookingDate: "",
      awbData: {},
      bookingData: {},
    });
    mutate(awbNo);
  };

  useEffect(() => {
    if (searchParams.get("awb")) {
      setAwbNo(searchParams.get("awb"));
      setAwbTrackingData({
        tracking_data: [],
        bookingDate: "",
        awbData: {},
        bookingData: {},
      });
      mutate(searchParams.get("awb"));
    }
  }, [searchParams]);

  const getTRline = (name, value, isEven: any = false) => {
    return (
      <tr className={isEven ? "bg-blue-100" : ""}>
        <td className="text-right pr-5  whitespace-nowrap">{name}</td>
        <td>{value}</td>
      </tr>
    );
  };

  const getChargeableWeight = (weight, product_code, ll, bb, hh) => {
    ll = Number(ll);
    bb = Number(bb);
    hh = Number(hh);
    let dWeight = (ll * bb * hh) / (product_code == "X" ? 2700 : 5000);
    return Math.max(Number(weight), dWeight);
  };

  const {
    mutate: mutateComment,
    isLoading: isCommentloading,
  }: {
    mutate: UseMutateFunction<AxiosResponse<any, any>, unknown, any, unknown>;
    isLoading: any;
  } = useMutation((data) => CreateCommanWay(data), {
    onSuccess: (data: any) => {
      console.log(data, data.status == "SUCCESS");
      if (data.status == "SUCCESS") {
        window.location.reload();
      } else {
        UseToast(data.message, "error");
      }
    },
    onError: (data: any) => {
      typeof data === "string" ? UseToast(data, "error") : UseToast(data.message, "error");
    },
  });

  const getDataLoggerLog = () => {
    try {
      let raw = awbTrackingData?.awbData?.dataLoggerLog;
      if (!raw) return {};
      while (typeof raw === "string") {
        raw = JSON.parse(raw);
      }
      return raw || {};
    } catch {
      return {};
    }
  };

  const GetCard = ({ className, children, display = "inline-block", flex = "", cityBlock = false }: any) => {
    return (
      <div className={display + ` ${flex} relative h-full rounded-2xl border p-1 md:rounded-3xl bg-slate-800/10`}>
        <GlowingEffect blur={0} borderWidth={3} spread={80} glow={true} disabled={false} proximity={64} inactiveZone={0.01} />
        <div
          className={`border-0.75 relative flex h-full flex-col justify-between gap-6 overflow-hidden rounded-xl px-4 py-2 dark:shadow-[0px_0px_27px_0px_#2D2D2D] bg-black-900-  ${
            cityBlock ? "city-block bg-black- bg-white" : "bg-white/60"
          }`}
        >
          <div className="relative flex items-center flex-col flex-1 justify-center gap-0 z-10">{children}</div>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className=" relative flex w-full flex-1 bg-white font-inter">
        {isImageOpen && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              background: "rgba(0,0,0,0.7)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 1000,
            }}
          >
            <div
              style={{
                position: "relative",
                background: "#fff",
                padding: "20px",
                borderRadius: "10px",
              }}
            >
              <button
                className="inline-block bg-red-700 text-white px-2 pt-1 pb-1 rounded-md"
                onClick={() => setIsImageOpen("")}
                style={{
                  position: "absolute",
                  top: "10px",
                  right: "10px",
                  border: "none",
                  cursor: "pointer",
                }}
              >
                ✖
              </button>

              <img
                src={get_file_url(isImageOpen)}
                alt={awbNo + "-pod-image"}
                style={{ width: "80vw", maxHeight: "80vh", objectFit: "contain" }}
              />
            </div>
          </div>
        )}

        {showVolume && (
          <div className="z-20 absolute left-0 top-0 w-full h-full bg-black-900 bg-opacity-20 flex items-center justify-center">
            <div className="rounded-xl border-2 border-primary px-4 py-2 bg-white relative">
              <div className="flex items-center justify-between bg-primary text-white p-2 rounded-lg">
                <p>Total Weight: {awbTrackingData?.awbData?.weight}</p>
                <button
                  className="px-1"
                  onClick={() => {
                    setShowVolume(false);
                  }}
                >
                  ✖
                </button>
              </div>

              <div>
                <table className="table mt-2">
                  <tbody>
                    <tr>
                      <th className="px-2 border-r">Sr.</th>
                      <th className="px-2">Lenght</th>
                      <th className="px-2">Width</th>
                      <th className="px-2">Height</th>
                      <th className="px-2">Weight</th>
                    </tr>
                    {awbTrackingData?.awbData?.innerItemsJson && awbTrackingData?.awbData?.innerItemsJson != "[]" ? (
                      JSON.parse(awbTrackingData?.awbData?.innerItemsJson).map((i, a) => {
                        return (
                          <tr className="border-t" key={a + "qwe"}>
                            <td className="px-4 border-r">{a + 1}</td>
                            <td className="px-4">{i.l}</td>
                            <td className="px-4">{i.b}</td>
                            <td className="px-4">{i.h}</td>
                            <td className="px-4">{i.weight}</td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr className="border-t">
                        <td className="px-4">1</td>
                        <td className="px-4">{awbTrackingData?.awbData?.l}</td>
                        <td className="px-4">{awbTrackingData?.awbData?.b}</td>
                        <td className="px-4">{awbTrackingData?.awbData?.h}</td>
                        <td className="px-4">{awbTrackingData?.awbData?.weight}</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}

        {showDataLogger && (
          <div
            className="fixed inset-0 bg-black-900 bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-50 p-4"
            onClick={() => setShowDataLogger(false)}
          >
            <div
              className="rounded-xl border-2 border-primary p-4 sm:p-5 bg-white relative w-full max-w-md shadow-2xl"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="flex items-center justify-between bg-primary text-white p-3 rounded-lg">
                <h3 className="font-semibold text-lg">Datalogger Details</h3>
                <button
                  className="text-white hover:text-gray-200 text-lg font-bold px-2 py-0.5 rounded cursor-pointer"
                  onClick={() => setShowDataLogger(false)}
                >
                  ✖
                </button>
              </div>

              <div className="mt-4">
                {(() => {
                  const dl = getDataLoggerLog();
                  const companyLower = (dl.deviceCompany || "").replaceAll(" ", "_").trim().toLowerCase();
                  const deviceNoLower = (dl.deviceNo || "").replaceAll(" ", "_").trim().toLowerCase();
                  const calibrationUrl =
                    companyLower && deviceNoLower
                      ? `https://api.airfield.express/logger-cert/${companyLower}-${deviceNoLower}.pdf`
                      : null;

                  return (
                    <table className="w-full text-base">
                      <tbody>
                        <tr className="border-b border-gray-100">
                          <td className="py-2.5 font-semibold text-gray-700 w-1/2">Logger Company:</td>
                          <td className="py-2.5 text-gray-900 font-medium">{dl.deviceCompany || "-"}</td>
                        </tr>
                        <tr className="border-b border-gray-100">
                          <td className="py-2.5 font-semibold text-gray-700 w-1/2">Logger Model No:</td>
                          <td className="py-2.5 text-gray-900 font-medium">{dl.deviceNo || "-"}</td>
                        </tr>
                        <tr className="border-b border-gray-100">
                          <td className="py-2.5 font-semibold text-gray-700 w-1/2">Logger Report pdf:</td>
                          <td className="py-2.5">
                            {dl.file ? (
                              <a
                                href={get_file_url(dl.file)}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-flex items-center gap-1.5 bg-blue-600 hover:bg-blue-700 text-white px-3 py-1.5 rounded-md text-sm font-medium transition duration-150 shadow-sm"
                              >
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                </svg>
                                View PDF
                              </a>
                            ) : (
                              <span className="text-gray-500">-</span>
                            )}
                          </td>
                        </tr>
                        <tr>
                          <td className="py-2.5 font-semibold text-gray-700 w-1/2">Calibration report:</td>
                          <td className="py-2.5">
                            {calibrationUrl ? (
                              <a
                                href={calibrationUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-flex items-center gap-1.5 bg-blue-600 hover:bg-blue-700 text-white px-3 py-1.5 rounded-md text-sm font-medium transition duration-150 shadow-sm"
                              >
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                                </svg>
                                View PDF
                              </a>
                            ) : (
                              <span className="text-gray-500">-</span>
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  );
                })()}
              </div>
            </div>
          </div>
        )}
        <div className="flex flex-col gap-4 px- mt-0 z-10 relative flex-1">
          <div className=" p-2 rounded-2xl">
            <h1 className="text-center mb-3 mt-0 text-2xl whitespace-nowrap  rounded-md bg-black-900/20">Courier Details</h1>

            <div className="flex justify-between gap-3 items-start">
              <div className="flex flex-col gap-3 flex-1">
                <div className="flex-1 flex gap-3">
                  <GetCard>
                    <table className="text-lg dark:text-white">
                      <tbody>
                        <tr>
                          <td className="text-right">Airway Bill No:</td>
                          <td className="pl-4">
                            <span className="bg-blue-800 text-white p-1 rounded-md">{awbNo}</span>
                          </td>
                        </tr>
                        {(() => {
                          let customFields: any = {};
                          try {
                            let cf = awbTrackingData?.awbData?.customFields;
                            if (cf) {
                              while (typeof cf === "string") { cf = JSON.parse(cf); }
                              customFields = cf;
                            }
                          } catch { customFields = {}; }
                          return (
                            <>
                              {customFields.mainAwb && (
                                <tr>
                                  <td className="text-right">Main AWB:</td>
                                  <td className="pl-4">
                                    <a className="text-blue-600 hover:text-blue-800 underline font-bold" href={`/customer-pod/tracking?awb=${customFields.mainAwb}`}>{customFields.mainAwb}</a>
                                  </td>
                                </tr>
                              )}
                              {customFields.codAwb && (
                                <tr>
                                  <td className="text-right">COD AWB:</td>
                                  <td className="pl-4">
                                    <a className="text-blue-600 hover:text-blue-800 underline font-bold" href={`/customer-pod/tracking?awb=${customFields.codAwb}`}>{customFields.codAwb}</a>
                                  </td>
                                </tr>
                              )}
                            </>
                          );
                        })()}
                        <tr>
                          <td className="text-right">Reference Code:</td>
                          <td className="pl-4">{awbTrackingData.bookingData.pickup_code || "N/A"}</td>
                        </tr>
                        <tr>
                          <td className="text-right">Book Date:</td>
                          <td className="pl-4">{moment(awbTrackingData.bookingData?.date, "DD-MM-YYYY HH:mm:ss").format("DD-MM-YYYY")}</td>
                        </tr>
                      </tbody>
                    </table>
                  </GetCard>
                  <div className="flex-1 flex">
                    <GetCard flex="flex-1" cityBlock={true}>
                      <div
                        className={cn(
                          "absolute inset-0",
                          "[background-size:20px_20px]",
                          "[background-image:radial-gradient(#95a5ff_1px,transparent_1px)]",
                          "dark:[background-image:radial-gradient(#404040_1px,transparent_1px)]"
                        )}
                      />
                      {/* Radial gradient for the container to give a faded look */}
                      <div className="pointer-events-none absolute inset-0 flex items-center justify-center bg-white [mask-image:radial-gradient(ellipse_at_center,transparent_50%,black)] dark:bg-black-900"></div>

                      <h3 className="text-blue-600 text-3xl z-10 font-poppins font-semibold">
                        {awbTrackingData.bookingData.shipper_city} &nbsp;⟶&nbsp; {awbTrackingData.awbData.destination}
                      </h3>
                    </GetCard>
                  </div>
                </div>
                <div className="flex-1 shipper-block relative">
                  <GetCard display={"block"}>
                    <div className="flex w-full text-lg">
                      <div className="min-w-44">Shipper Name: </div>
                      <div className="mr-48">{awbTrackingData.bookingData.shipper_sh}</div>
                    </div>
                    <div className="flex w-full text-lg">
                      <div className="min-w-44">Shipper Addr: </div>
                      <div className="mr-48">{awbTrackingData.bookingData.shipper_address}</div>
                    </div>
                  </GetCard>
                </div>
                <div className="flex-1 cgnee-block relative">
                  <GetCard display={"block"}>
                    <div className="flex w-full text-lg">
                      <div className="min-w-44">Consignee Name: </div>
                      <div className="mr-48">{awbTrackingData.awbData.consignee}</div>
                    </div>
                    <div className="flex w-full text-lg">
                      <div className="min-w-44">Consignee Addr: </div>
                      <div className="mr-48">{awbTrackingData.awbData.address}</div>
                    </div>
                    <div className="flex w-full text-lg">
                      <div className="min-w-44">Pincode: </div>
                      <div>{awbTrackingData.awbData.pincode}</div>
                    </div>
                  </GetCard>
                </div>
                <div className="flex justify-between gap-3">
                  <GetCard flex="flex-1">
                    <table className="text-lg dark:text-white">
                      <tbody>
                        <tr>
                          <td className="text-right">Product:</td>
                          <td className="pl-4">
                            {productList
                              .map((p) => {
                                return p.product_code == awbTrackingData.awbData.prefix ? p.product_name : "";
                              })
                              .join("")}
                          </td>
                        </tr>
                        <tr>
                          <td className="text-right whitespace-nowrap">Doc Type:</td>
                          <td className="pl-4">{awbTrackingData.awbData.dox_or_non_dox ? "DOX" : "Non-Dox"}</td>
                        </tr>
                        {(() => {
                          const dl = getDataLoggerLog();
                          const hasDataLogger = Boolean(dl?.deviceCompany || dl?.deviceNo || dl?.file);
                          if (!hasDataLogger) return null;
                          return (
                            <tr>
                              <td colSpan={2} className="text-center">
                                <Button
                                  className="bg-blue-600 px-2 py-1 rounded-md text-white mr-3"
                                  onClick={() => {
                                    setShowDataLogger(true);
                                  }}
                                >
                                  Datalogger
                                </Button>
                              </td>
                            </tr>
                          );
                        })()}
                      </tbody>
                    </table>
                  </GetCard>
                  <GetCard flex="flex-1">
                    <table className="text-lg dark:text-white">
                      <tbody>
                        <tr>
                          <td className="text-right">Weight:</td>
                          <td className="pl-4 underline whitespace-nowrap">{awbTrackingData.awbData.weight} kg</td>
                        </tr>
                        <tr>
                          <td className="text-right whitespace-nowrap">Chargeable Weight:</td>
                          <td className="pl-4 underline whitespace-nowrap">
                            {getChargeableWeight(
                              awbTrackingData.awbData.weight,
                              awbTrackingData.awbData.prefix,
                              awbTrackingData.awbData.l,
                              awbTrackingData.awbData.b,
                              awbTrackingData.awbData.h
                            )}{" "}
                            kg
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={2} className="text-center">
                            <Button
                              className="bg-blue-600 px-2 py-1 rounded-md text-white mr-3"
                              onClick={() => {
                                setShowVolume(true);
                              }}
                            >
                              Show Volume Info
                            </Button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </GetCard>
                  <GetCard flex="flex-1">
                    <table className="text-lg dark:text-white">
                      <tbody>
                        <tr>
                          <td className="text-right">Holiday:</td>
                          <td className="pl-4">{awbTrackingData.awbData.holiday ? "YES" : "NO"}</td>
                          <td className="text-right pl-6">FOD:</td>
                          <td className="pl-4">{awbTrackingData.awbData.isFod ? "YES" : "NO"}</td>
                        </tr>
                        <tr>
                          <td className="text-right">10_30:</td>
                          <td className="pl-4">{awbTrackingData.awbData.is10_30 ? "YES" : "NO"}</td>
                          <td className="text-right pl-6">COD:</td>
                          <td className="pl-4">{awbTrackingData.awbData.isCod ? "YES" : "NO"}</td>
                        </tr>
                        <tr>
                          <td colSpan={2} className="text-center">
                            <Link
                            target="_blank"
                            to={'/awb/slip?awb='+awbNo}
                              className="bg-green-600 px-2 py-1 rounded-md text-white mr-3 inline-block"
                            >
                              Print Airwaybill
                            </Link>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </GetCard>
                </div>
              </div>

              <div className="min-w-[350px] dark">
                <div className={` relative h-full rounded-2xl border p-1 md:rounded-3xl bg-slate-800/10`}>
                  <GlowingEffect blur={0} borderWidth={3} spread={80} glow={true} disabled={false} proximity={64} inactiveZone={0.01} />
                  <div className="border-0.75 relative flex h-full flex-col justify-between gap-6 overflow-hidden rounded-xl px-4 py-2 dark:shadow-[0px_0px_27px_0px_#2D2D2D] blue-grad text-white">
                    <div>
                      <div className="relative flex flex-col flex-1 gap-0">
                        {awbTrackingData.tracking_data.map((t, idx) => {
                          let isCurrent = idx == awbTrackingData.tracking_data.length - 1;
                          return (
                            <div className={`relative pl-10 ${isCurrent ? "bg-black-900 py-2 rounded-md" : "pb-3"}`} key={idx + "asdw"}>
                              {isCurrent && (
                                <span className="inline-block mb-2 bg-white text-blue-600 px-2 rounded-md">Current Status</span>
                              )}
                              {/* Line */}
                              <div className="absolute left-[19px] top-0 bottom-0 w-1 bg-white" />

                              {/* Dot */}
                              <div className="absolute left-3 top-1 w-4 h-4 bg-blue-500 rounded-full border-2 border-white z-10" />

                              {/* Content */}
                              <h3 className="text-sm font- text-gray-50 font-montserrat ">{t.message_code}</h3>
                              <time className="text-xs text-white ">{t.updatedAt || t.createdAt}</time>
                              <p className="text-white mt-1 font-montserrat">{t.subtitle || ""}</p>

                              {t.message_code == "Shipment Delivered" && t.photo && (
                                <Button
                                  className="bg-orange-700 px-2 py-1 rounded-md text-white mr-3 mt-2"
                                  onClick={() => {
                                    setIsImageOpen(t.photo);
                                  }}
                                >
                                  POD Image
                                </Button>
                              )}

                              {t.message_code == "Shipment Delivered" && t.signature && (
                                <Button
                                  className="bg-orange-700 px-2 py-1 rounded-md text-white mr-3 mt-2"
                                  onClick={() => {
                                    setIsImageOpen(t.signature);
                                  }}
                                >
                                  Sign Photo
                                </Button>
                              )}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex gap-2 hidden">
              <table>
                <tbody>
                  {awbTrackingData.tracking_data[awbTrackingData.tracking_data.length - 1]?.message_code.includes("RTO") &&
                    getTRline(
                      <b>RTO Awb No.</b>,
                      <a style={{ color: "blue" }} href={`/customer-pod/tracking?awb=${awbTrackingData.awbData?.returnAwb}`}>
                        {awbTrackingData.awbData?.returnAwb}
                      </a>
                    )}
                </tbody>
              </table>
            </div>
          </div>

          {showImg && (
            <div className="flex gap-4">
              {awbTrackingData.tracking_data[awbTrackingData.tracking_data.length - 1]?.signature && (
                <Img
                  className="h-48"
                  src={get_file_url(awbTrackingData.tracking_data[awbTrackingData.tracking_data.length - 1]?.signature)}
                />
              )}
              {awbTrackingData.tracking_data[awbTrackingData.tracking_data.length - 1]?.photo && (
                <Img className="h-48" src={get_file_url(awbTrackingData.tracking_data[awbTrackingData.tracking_data.length - 1]?.photo)} />
              )}
            </div>
          )}
        </div>

        <div
          className={cn(
            "absolute inset-0",
            "[background-size:40px_40px]",
            "[background-image:linear-gradient(to_right,#e4e4e7_1px,transparent_1px),linear-gradient(to_bottom,#e4e4e7_1px,transparent_1px)]",
            "dark:[background-image:linear-gradient(to_right,#262626_1px,transparent_1px),linear-gradient(to_bottom,#262626_1px,transparent_1px)]"
          )}
        />
        <div className="pointer-events-none absolute inset-0 flex items-center justify-center bg-white [mask-image:radial-gradient(ellipse_at_center,transparent_20%,black)] dark:bg-black-900"></div>
      </div>
    </>
  );
};

export default CustomerTrackingAwb;
